import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  parseDocument: (
    document: string,
    citizenship: string,
    cfg?: AxiosConfig,
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($document: UploadPath! $citizenship: UUID!) {
          parseDocument(document: $document citizenship: $citizenship) {
            data {
              lastName { ru en }
              noLastName
              firstName { ru en }
              noFirstName
              patronymic { ru en }
              noPatronymic
              sex
              birthdate
              citizenship { id }
              documentype
              documentseries
              documentnumber
              birthplace
              issuingauthority
              issuedata
              expirationdate
            }
            token
          }
        }
      `,
      variables: { document, citizenship },
    }, cfg),
  ),
})
